/* eslint-env browser, jquery */
import React from 'react';
import { render } from 'react-dom';
import domify from 'domify';
import container from 'modules/section-content';
import page from 'modules/ab-page-js';
import metadata from './data/metadata.json';
import layout from './views/index.pug';
import { Router } from './containers';
import clientRouter from './utils/clientRouter';

const pageEvents = {};

export default function register() {
  page('/gdpr-assessment/', renderPage);
  page('/gdpr-assessment/:route', renderPage);
  page.exit('/gdpr-assessment/:route', cleanUp);
}

function renderPage(ctx, next) {
  const route = `/${ctx.params.route || ''}`;

  if (route === '/') {
    showHeader();
  } else {
    hideHeader();
  }

  if (!ctx.init && pageEvents.listener) {
    pageEvents.listener(route);
    return next();
  }

  if (!ctx.init) {
    return next();
  }

  const initialState = window.INITIAL_STATE_GDPR_ASSESMENT_TOOL;
  const RenderRouter = clientRouter(Router, route, pageEvents, page);

  const renderOptions = {
    gdprAssesmentTool: render(
      <RenderRouter {...initialState} />,
      document.getElementById('gdpr-assessment-tool')
    ),
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(layout()) })
  };
  container.render(renderOptions);

  return next();
}

function cleanUp(ctx, next) {
  showHeader();
  next();
}

function hideHeader() {
  $('#header').css({ display: 'none' });
  $('footer').css({ display: 'none' });
}

function showHeader() {
  $('#header').css({ display: 'block' });
  $('footer').css({ display: 'block' });
}



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/client.js